export * from './bad-routing';
export * from './mail-action';
export * from './mail-destinataire';
export * from './mail-details-dto.';
export * from './mail-duplicate';
export * from './mail-file';
export * from './mail-full';
export * from './mail-kanban';
export * from './mail-me-count';
export * from './mail-publipostage';
export * from './mail-service';
export * from './mail-signature';
export * from './mail-status';
export * from './mail-validation';
export * from './mail';
export * from './mails-echeancier';
export * from './mails-lock';
export * from './mails-me-search';
export * from './mails-search';
